declare global {
  interface Window {
    __zd_bound?: boolean;
    __zd_loaded?: boolean;
    __zd_last_path?: string;
    zE?: (...args: any[]) => void;
    zEmbed?: unknown;
    zEWebpackACJsonp?: unknown;
    zEACLoaded?: boolean;
  }
}

const LOCATION_PATH = '/mypage';
const ZENDESK_SNIPPET_ID = 'ze-snippet';
const ZENDESK_SNIPPET_SRC =
  'https://static.zdassets.com/ekr/snippet.js?key=e34b7f00-02fd-47fe-9643-be4004a588bf';
const ZENDESK_LAUNCHER_ID = 'launcher';
const ZENDESK_IFRAME_TITLE_JP = 'メッセージ';
const ZENDESK_IFRAME_TITLE_EN = 'messaging';
const ZENDESK_SRC_SUBSTRING = 'zendesk';
const ZD_ASSETS_SRC_SUBSTRING = 'zdassets';
const ZENDESK_GLOBAL_KEYS = ['zE', 'zEmbed', 'zEWebpackACJsonp', 'zEACLoaded'] as const; // これを削除しないと再初期化できない
let zendeskLauncherObserver: MutationObserver | null = null;

function removeZendeskDom() {
  const launcher = document.getElementById(ZENDESK_LAUNCHER_ID);
  if (launcher) {
    let node: HTMLElement = launcher;
    while (node.parentElement && node.parentElement !== document.body) {
      node = node.parentElement;
    }
    node.remove();
  }

  document.querySelectorAll<HTMLIFrameElement>('iframe').forEach((iframe) => {
    const id = iframe.id || '';
    const title = iframe.getAttribute('title') || '';
    const src = iframe.getAttribute('src') || '';
    const matches =
      id === ZENDESK_LAUNCHER_ID ||
      title.includes(ZENDESK_IFRAME_TITLE_JP) ||
      title.toLowerCase().includes(ZENDESK_IFRAME_TITLE_EN) ||
      src.includes(ZENDESK_SRC_SUBSTRING) ||
      src.includes(ZD_ASSETS_SRC_SUBSTRING);
    if (matches) {
      iframe.remove();
    }
  });
}

function ensureZendeskLauncherObserver() {
  if (zendeskLauncherObserver || !document.body) {
    return;
  }

  zendeskLauncherObserver = new MutationObserver(() => {
    const launcher = document.getElementById(ZENDESK_LAUNCHER_ID) as HTMLIFrameElement | null;
    if (launcher) {
      launcher.style.opacity = '0';
      launcher.style.transition = 'opacity 150ms ease';
      launcher.addEventListener(
        'load',
        () => {
          launcher.style.opacity = '';
        },
        { once: true },
      );
      zendeskLauncherObserver?.disconnect();
      zendeskLauncherObserver = null;
    }
  });

  zendeskLauncherObserver.observe(document.body, { childList: true, subtree: true });
}

function clearZendeskGlobals() {
  const globalWindow = window as unknown as Record<string, unknown>;
  ZENDESK_GLOBAL_KEYS.forEach((key) => {
    try {
      delete globalWindow[key];
    } catch {
      globalWindow[key] = undefined;
    }
  });
}

function resetZendeskWidget() {
  window.__zd_loaded = false;
  clearZendeskGlobals();

  if (zendeskLauncherObserver) {
    zendeskLauncherObserver.disconnect();
    zendeskLauncherObserver = null;
  }

  removeZendeskDom();

  const script = document.getElementById(ZENDESK_SNIPPET_ID);
  if (script) {
    script.remove();
  }
}

function insertZendeskSnippet() {
  if (!document.body) {
    return;
  }

  const script = document.createElement('script');
  script.id = ZENDESK_SNIPPET_ID;
  script.src = ZENDESK_SNIPPET_SRC;
  script.async = true;
  script.addEventListener('load', () => {
    window.__zd_loaded = true;
    if (typeof window.zE === 'function') {
      window.zE('messenger', 'show');
    }
    ensureZendeskLauncherObserver();
  });
  document.body.appendChild(script);
}

function onZendeskRouteChanged() {
  const currentPath = location.pathname;
  const isSamePath = window.__zd_last_path === currentPath;
  if (isSamePath && window.__zd_loaded) {
    return;
  }
  window.__zd_last_path = currentPath;

  resetZendeskWidget();

  if (currentPath === LOCATION_PATH) {
    insertZendeskSnippet();
  }
}

export function initZendeskChatBot() {
  try {
    if (window.__zd_bound) {
      return;
    }
    window.__zd_bound = true;
    document.addEventListener('turbo:load', onZendeskRouteChanged);
    document.addEventListener('turbo:frame-load', onZendeskRouteChanged);
    document.addEventListener('turbo:before-visit', () => {
      if (location.pathname === LOCATION_PATH) {
        resetZendeskWidget();
      }
    });
  } catch (_error) {
    /* no-op */
  }
}
